import { React, useState, useEffect } from "react";
import HeaderB from "../Header/HeaderB";
import GoBackLink from "../GoBacklink/GoBackLink";
import ProductThumbNailGroup from "../ProductThumbNailGroup/ProductThumbNailGroup";
import AddToCartB from "../AddToCart/AddToCartB";
import BestGear from "../BestGear/BestGear";
import AlsoLike from "../AlsoLike/AlsoLike";
import Footer from "../Footer/Footer";
import Features from "../Features/Features";
import markOne from "../../assets/shared/desktop/image-xx99-mark-one-headphones.jpg";
import markOneTab from "../../assets/shared/tablet/image-xx99-mark-one-headphones.jpg";
import markOneMobile from "../../assets/shared/mobile/image-xx99-mark-one-headphones.jpg";
import marktwo from "../../assets/shared/desktop/image-xx99-mark-two-headphones.jpg";
import marktwoTab from "../../assets/shared/tablet/image-xx99-mark-two-headphones.jpg";
import marktwoMobile from "../../assets/shared/mobile/image-xx99-mark-two-headphones.jpg";
import speaker from "../../assets/shared/desktop/image-zx9-speaker.jpg";
import speakerTab from "../../assets/shared/tablet/image-zx9-speaker.jpg";
import speakerMobile from "../../assets/shared/mobile/image-zx9-speaker.jpg";
import xx59Img from "../../assets/product-xx59-headphones/desktop/image-product.jpg";
import xx59ImgTab from "../../assets/product-xx59-headphones/tablet/image-product.jpg";
import xx59ImgMobile from "../../assets/product-xx59-headphones/mobile/image-product.jpg";

import ProductGallery from "../ProductGallery/ProductGallery";
import imgGallery1 from "../../assets/product-xx59-headphones/desktop/image-gallery-1.jpg";
import imgGallery2 from "../../assets/product-xx59-headphones/desktop/image-gallery-2.jpg";
import imgGallery3 from "../../assets/product-xx59-headphones/desktop/image-gallery-3.jpg";

const HeadphonesXX59 = ({
  addXX59ToCart,
  cart,
  updateMyCart,
  updateQuantity,
  increment,
  decrement,
  quantity,
}) => {
  const [xx59active, setxx59Active] = useState("");
  const [markOneURL, setMarkOneURL] = useState("");
  const [markTwoURL, setMarkTwoURL] = useState("");
  const [speakerURL, setSpeakerURL] = useState("");
  useEffect(() => {
    const handleResize = () => {
      console.log("Resizing...");
      if (window.innerWidth <= 450) {
        console.log("Resizing for HeadphonesMarkOne.jsx mobile view");
        setxx59Active(xx59ImgMobile);
        setMarkOneURL(markOneMobile);
        setSpeakerURL(speakerMobile);
        setMarkTwoURL(marktwoMobile);
      } else if (window.innerWidth <= 768) {
        console.log("Resizing for HeadphonesMarkOne.jsx tablet view");
        setxx59Active(xx59ImgTab);
        setMarkOneURL(markOneTab);
        setSpeakerURL(speakerTab);
        setMarkTwoURL(marktwoTab);
      } else {
        console.log("Resizing for HeadphonesMarkOne.jsx desktop view");
        setxx59Active(xx59Img);
        setMarkOneURL(markOne);
        setSpeakerURL(speaker);
        setMarkTwoURL(marktwo);
      }

      console.log("Resize in Progress");
    };
    handleResize();
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  return (
    <>
      <HeaderB
        cart={cart}
        updateCartQuantity={updateQuantity}
        increment={increment}
        decrement={decrement}
        quantity={quantity}
      />
      <main>
        <GoBackLink />
        <AddToCartB
          imageURL={xx59active}
          productName={
            <>
              XX59
              <br /> Headphones
            </>
          }
          description="
          Enjoy your audio almost anywhere and customize it to your specific tastes with the XX59 headphones. 
          The stylish yet durable versatile wireless headset is a brilliant companion at home or on the move."
          price="999"
          addItem={updateMyCart}
          updateQuantity={updateQuantity}
          quantity={quantity}
          increment={increment}
          decrement={decrement}
        />
        <Features
          p1="These headphones have been created from durable, high-quality materials tough enough to take anywhere. Its compact
          folding design fuses comfort and minimalist style making it perfect for travel. Flawless transmission is assured by the
          latest wireless technology engineered for audio synchronization with videos."
          p2="More than a simple pair of headphones, this headset features a pair of built-in microphones for clear, hands-free
        calling when paired with a compatible smartphone. Controlling music and calls is also intuitive thanks to easy-access
        touch buttons on the earcups. Regardless of how you use the XX59 headphones, you can do so all day thanks to an
        impressive 30-hour battery life that can be rapidly recharged via USB-C."
        />
        <ProductGallery image={[imgGallery1, imgGallery2, imgGallery3]} />
        <AlsoLike
          image={[markTwoURL, markOneURL, speakerURL]}
          title={["XX99 MARK II", "XX99 MARK I", "ZX9 SPEAKER"]}
          nav1={"/headphones/markTwo"}
          nav2={"/headphones/markOne"}
          nav3={"/speakerZx9"}
        />
        <ProductThumbNailGroup />
        <BestGear />
        <Footer />
      </main>
    </>
  );
};

export default HeadphonesXX59;
